

















    import {
        Component,
        Vue
    } from 'vue-property-decorator'
    import { getModule } from 'vuex-module-decorators'
    import UserModule from '@/store/modules/UserModule'
    import LocomotivesModule from '@/store/modules/LocomotivesModule'
    import * as L from 'leaflet'
    import {
        SignalRService
    } from '@/services/SignalRService'
    import LocoSectionGraphs from '@/components/LocoSectionGraphs.vue'
import LocoSectionWithParameters from '../models/Graph/LocoSectionWithParameters'

    @Component({
        components: {
            LocoSectionGraphs
        }
    })
    export default class Map extends Vue {
        private signalRService = new SignalRService()
        private locomotiveModule = getModule(LocomotivesModule, this.$store)
        private userModule = getModule(UserModule, this.$store)

        private zoom = 5
        private url = 'https://{s}.tile.osm.org/{z}/{x}/{y}.png'
        private attribution = '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors'
        private center = [47.413220, -1.219482]
        private icon!: L.Icon<L.IconOptions>
        private errorIcon!: L.DivIcon
        private currentBounds!: L.LatLngBounds
        private locomotiveParametersIsVisible = false
        private locoSectionWithParameters = new LocoSectionWithParameters()

        private get locomotivesPositions() {
            return this.locomotiveModule.locomotivesPositions
        }

        // private get locoSectionWithParameters() {
        //     return this.locomotiveModule.locomotivesParameters
        // }

        mounted(): void {
            this.errorIcon = L.divIcon({
            className: 'css-icon',
            html: '<svg width="48" height="48" viewbox="0 0 40 40" xmlns="http://www.w3.org/2000/svg"><circle cx="20" cy="20" fill="none" r="10" stroke="red" stroke-width="2"><animate attributeName="r" from="8" to="20" dur="1.5s" begin="0s" repeatCount="indefinite"/><animate attributeName="opacity" from="1" to="0" dur="1.5s" begin="0s" repeatCount="indefinite"/></circle><circle cx="20" cy="20" fill="red" r="10"/></svg>',
            iconSize: [22,22]
            // ,iconAnchor: [11,11]
            })

            this.icon = L.icon({
                iconUrl: 'https://static.thenounproject.com/png/1475149-200.png',
                iconSize: [32, 32]
            })

            this.userModule.generateUserId()

            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(this.success, this.fail, {
                    maximumAge: 60000,
                    timeout: 10000,
                    enableHighAccuracy: true
                })
            }
        }
        locoSectionHasErrors(locoSectionCode: string): boolean {
            return this.locomotiveModule.locoSectionErrors.find((le) => le.locoSection == locoSectionCode) != null
        }
        getLocoSectionErrorText(locoSectionCode: string): string {
            return this.locomotiveModule.locoSectionErrors.find((le) => le.locoSection == locoSectionCode)!.error
        }
        getPopupText(locoSectionCode: string): string {
            if (this.locoSectionHasErrors(locoSectionCode)) {
                return `${locoSectionCode}<br>${this.getLocoSectionErrorText(locoSectionCode)}`
            }
            return locoSectionCode
        }
        async success(position: Position) {
            this.center = [position.coords.latitude, position.coords.longitude]
            const userId = this.userModule.userId

            this.signalRService.start(userId, {
                top: this.currentBounds.getNorth(),
                bottom: this.currentBounds.getSouth(),
                left: this.currentBounds.getWest(),
                right: this.currentBounds.getEast()
            })
        }
        fail(error: PositionError) {
            if (error) {
                switch (error.code) {
                    case error.PERMISSION_DENIED:
                        alert('User denied the request for Geolocation.')
                        break
                    case error.POSITION_UNAVAILABLE:
                        alert('Location information is unavailable.')
                        break
                    case error.TIMEOUT:
                        alert('The request to get user location timed out.')
                        break
                }
                console.error(error)
            }
        }
        onReady(map: L.Map) {
            this.currentBounds = map.getBounds()
        }
        onMoveEnded(bounds: L.LatLngBounds){
            this.currentBounds = bounds
        }
        async locoSectionClicked(locoSection: string) {
            const dateFrom = new Date('2019-12-11 14:12:15')
            const dateTo = new Date('2019-12-12 17:12:15')

            const url = `/api/v1/OnlineLocomotiveParameters?locoSection=${locoSection}&from=${dateFrom.toISOString()}&to=${dateTo.toISOString()}`
            const params = await (await fetch(url, {
              headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
              }
            })).json()
            this.locoSectionWithParameters = params
            debugger
            // await this.locomotiveModule.getLastLocomotivesParameters({
            //     locoSection: locoSection,
            //     dateFrom: dateFrom,
            //     dateTo: dateTo
            // })
            await this.signalRService.subscribeToSection(locoSection, (data) => {
                this.locomotiveModule.setLocomotivesParameters(data.parameters)
            })
            this.locomotiveParametersIsVisible = true
        }
    }
